import React, { useMemo, useState, useEffect } from 'react';
import { useIntl, getLocale } from 'umi';
import classnames from 'classnames';
import { SelectMultiple } from 'tea-component';
import { renderImgText } from '@/pages/intelligence/components/TeaSelector/MultipleSelector';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';
import { isSameArrayValue } from '../../utils';

export default function RegionSelect(props: any) {
  const { value: valueOuter, onChange, opts: optsOuter, name, className } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const localeTextField = locale === LANGUAGE_CN ? 'labelCN' : 'label';

  const allText = formatMessage({ id: 'dbi_all' });

  const opts = useMemo(() => {
    if (!Array.isArray(optsOuter)) return [];
    return optsOuter.map((item: any) => {
      const text = item?.[localeTextField] || item?.label || item?.value;
      return {
        ...item,
        text: renderImgText(text, item?.icon),
      };
    });
  }, [localeTextField, optsOuter]);

  const [value, setValue] = useState<string[]>([]);
  useEffect(() => {
    const valueTmp = Array.isArray(valueOuter) ? valueOuter : [];
    setValue(valueTmp);
  }, [valueOuter]);

  const getShowEmben = (selected: any[]) => {
    const len = selected?.length;
    if (!len) return '';
    if (len === opts?.length) return allText;
    if (len > 2) return len;
    if (len === 1) {
      const selectedTarget = selected?.[0];
      return selectedTarget?.[localeTextField]
        ?? selectedTarget?.label
        ?? selectedTarget?.text
        ?? selectedTarget?.value;
    }
    return selected?.reduce((x: any, y: any) => {
      const xstr = x?.[localeTextField] ?? x?.label ?? x?.text ?? x?.value;
      const ystr = y?.[localeTextField] ?? y?.label ?? y?.text ?? y?.value;
      return `${xstr},${ystr}`;
    });
  };

  return (
    <SelectMultiple
      className={classnames('select-item dbi-top-genre-market-select', className)}
      overlayClassName="dbi-top-genre-market-select-overlay"
      staging={false}
      size="m"
      matchButtonWidth
      appearance="button"
      listHeight={235}
      allOption={{
        value: 'all',
        text: allText,
      }}
      button={(selected) => (
        <div className="select-button">
          <div className="select-button-text">{name}</div>
          <div className="dbi-select-flex">{getShowEmben(selected)}</div>
        </div>
      )}
      options={opts}
      value={value}
      onChange={(values) => setValue(values)}
      onClose={() => {
        if (isSameArrayValue(value, valueOuter)) return;
        if (value?.length) {
          onChange?.(value);
          return;
        }
        const valueTmp = opts?.map((opt: any) => opt?.value) || [];
        setValue(valueTmp);
        onChange?.(valueTmp);
      }}
    />
  );
}
